import { action as apiAction } from 'api/Api'
import {
  removeLabel as removeLabelFromCard
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
  labelId: number
}

export default (payload: Payload) => async dispatch => {
  const { id, labelId } = payload

  const optimisticAction = optimisticDispatch(dispatch, removeLabelFromCard({
    id,
    labelId
  }))

  try {
    await apiAction('RemoveLabelFromCard', {
      cardId: id,
      labelId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code !== 303) { // NoChange
      throw error
    }
  }
}
